"use client"

import { ArrowDown01 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowDown01Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowDown01Icon = component(Icon)({ as: ArrowDown01 })
